import React from "react";

const OrganicFacialProcess = () => {
  return (
    <div className="organicFacialWhy">
      <h4>
        The Process: What to Expect from Our Organic Facial Services in
        Bangalore
      </h4>
      <p>
        When you book an{" "}
        <a href="https://scentlifestyle.com/organic-facial-services">
          organic facial service in Bangalore at SCENT,
        </a>{" "}
        you can expect a luxurious and personalized experience from start to
        finish. Here’s what the process typically involves:
      </p>
      <ul>
        <li>
          <h6> 1. Consultation:</h6> Your treatment begins with a thorough
          consultation with one of our expert estheticians. We discuss your skin
          concerns, goals, and preferences to tailor the facial to your specific
          needs.
        </li>
        <li>
          <h6> 2. Cleansing:</h6> The first step of the facial is a gentle
          cleanse using an organic cleanser suited to your skin type. This
          removes impurities and prepares your skin for the treatment.
        </li>
        <li>
          <h6> 3. Exfoliation:</h6> Next, we use a natural exfoliant to slough
          off dead skin cells and reveal a fresher, brighter complexion. This
          step enhances the absorption of subsequent products.
        </li>
        <li>
          <h6> 4. Extraction: </h6>If necessary, we perform gentle extractions
          to clear clogged pores and reduce breakouts. Our techniques are
          designed to be as comfortable as possible.
        </li>
        <li>
          <h6> 5. Massage:</h6> A relaxing facial massage follows, using organic
          oils and serums. This not only feels divine but also promotes
          circulation and lymphatic drainage.
        </li>
        <li>
          <h6> 6. Mask: </h6>We then apply a customized organic mask tailored to
          your skin concerns. Whether you need hydration, detoxification, or
          brightening, we have the perfect mask for you.
        </li>
        <li>
          <h6> 7. Moisturization:</h6> The final step is the application of an
          organic moisturizer to lock in hydration and nourish your skin. We
          also apply sunscreen to protect your skin from UV damage.
        </li>
      </ul>
    </div>
  );
};

export default OrganicFacialProcess;
